import {
  Actions,
  Button,
  Dialog,
  Divider,
  IconPersonAdd,
  Text,
} from 'braid-design-system';
import { useId, useState } from 'react';

import { InvitationList } from './components/InvitationList/InvitationList.tsx';
import { NewUserForm } from './components/NewUserForm/NewUserForm.tsx';
import { UsersList } from './components/UsersList/UsersList.tsx';

import { BasePage } from '#src/components/BasePage/BasePage.tsx';
import type { Breadcrumb } from '#src/components/Breadcrumbs/Breadcrumbs.tsx';
import { NoPermissionAlert } from '#src/components/NoPermissionAlert/NoPermissionAlert.tsx';
import { usePermissions } from '#src/hooks/auth.tsx';

export const UsersPage = ({ breadcrumbs }: { breadcrumbs: Breadcrumb[] }) => {
  const [showNewUserDialog, setShowNewUserDialog] = useState(false);
  const { permissions } = usePermissions();

  const hasReadAccess = permissions.includes('query:users');
  const hasWriteAccess = permissions.includes('mutate:users');

  const dialogId = useId();

  return (
    <BasePage title="Users" breadcrumbs={breadcrumbs}>
      <Text>
        View & manage users who have access to SEEK’s Developer Dashboard.
      </Text>

      {hasWriteAccess && (
        <Actions>
          <Button
            size="small"
            tone="brandAccent"
            onClick={() => setShowNewUserDialog(true)}
            icon={<IconPersonAdd />}
          >
            Add user
          </Button>
        </Actions>
      )}

      {!hasReadAccess ? (
        <NoPermissionAlert subject="view users" />
      ) : (
        <>
          <UsersList />
          {
            <>
              <Divider />
              <InvitationList />
              <Dialog
                id={dialogId}
                open={showNewUserDialog}
                onClose={() => setShowNewUserDialog(false)}
                title="Add new user"
              >
                <NewUserForm closeDialog={() => setShowNewUserDialog(false)} />
              </Dialog>
            </>
          }
        </>
      )}
    </BasePage>
  );
};
